import window from 'window-or-global';
import { bind, trigger } from '@confluence-classic/confluence-event_DO_NOT_USE';

import { getBootstrapManager } from '../../tech-debt/facades/editor';

import { initMentionAnalytics } from './mentions/mention-analytics';

const MentionAutocompletePlugin = require('./mentions/editor-plugin').default;

initMentionAnalytics();

bind('rte-pre-resolveplugins', () => {
	const bootstrapManager = getBootstrapManager();

	window.tinymce.create('tinymce.plugins.MentionsAutoComplete', MentionAutocompletePlugin);
	window.tinymce.PluginManager.add('fabricmention', window.tinymce.plugins.MentionsAutoComplete);
	bootstrapManager.addTinyMcePluginInit((settings) => {
		settings.plugins += ',fabricmention';
	});
});

export const triggerEditorPluginsLoaded = () => {
	// Use to signal editor-loader that frontend editor plugins resources are loaded
	trigger('frontend.editor.plugins.resources.loaded');
};
